import dayjs from 'dayjs'

import { Date } from '@cook-types/cook'

import { Timeframe } from './types'
import {
  MultilineHighFive,
  MultilineHighFiveContent,
  MultilineHighFiveSubContentItem,
} from '@widgets/Multiline/types'

export const formatTime = (value: string, format: string) => {
  if (!value || !format) {
    return ''
  }

  const parsedDate = dayjs(value, format)
  if (!parsedDate.isValid()) {
    return ''
  }
  return parsedDate.tz('Europe/Zurich').format('HH:mm')
}

export const getLatestDate = (dates: Date[]) => {
  const parsedDates = dates.map((dateObj) =>
    dayjs(dateObj.value, dateObj.format)
  )
  const mostRecentDate = parsedDates.reduce((accumulator, currentValue) =>
    currentValue && currentValue.isValid() && accumulator.isAfter(currentValue)
      ? accumulator
      : currentValue
  )
  return mostRecentDate.tz('Europe/Zurich').format('HH:mm')
}

export const getTimeframeString = () => {
  const currentHour = dayjs().format('H')
  const hourNumber = parseInt(currentHour)
  if (!hourNumber || isNaN(hourNumber)) {
    return ''
  }
  if (hourNumber >= 23 && hourNumber <= 3) {
    return Timeframe.CETTE_NUIT
  }
  if (hourNumber === 12) {
    return Timeframe.CE_MIDI
  }
  if (hourNumber >= 13 && hourNumber <= 17) {
    return Timeframe.CET_APRÈS_MIDI
  }
  if (hourNumber >= 18 && hourNumber <= 22) {
    return Timeframe.CE_SOIR
  }

  return Timeframe.CE_MATIN
}

export const isHighFiveItemData = (
  data: any
): data is MultilineHighFiveSubContentItem =>
  !!data.title &&
  !!data.updatedDate?.format &&
  !!data.updatedDate?.value &&
  !!data.articleId

const isHighFiveItem = (item: any): item is MultilineHighFiveSubContentItem =>
  !!item?.content?.every(isHighFiveItemData)

export const isHighFiveContent = (
  content: MultilineHighFive['content']
): content is MultilineHighFiveContent => content.every(isHighFiveItem)
